import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=6dc7b43a&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=6dc7b43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7b43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc7b43a')) {
      api.createRecord('6dc7b43a', component.options)
    } else {
      api.reload('6dc7b43a', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=6dc7b43a&scoped=true&", function () {
      api.rerender('6dc7b43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/panels/Address.vue"
export default component.exports